module.exports = {
  name: 'experience-list',
  buttonClass: 'button small primary',
  wrapperClass: 'pagination-wrapper row justify-content-center',
}
